import { defineColumns } from '@juvare/platform-shared/features/storage';
export const groupEntityName = 'group';
export const groupIdPrefixForAlertService = 'group_';
export const groupColumns = defineColumns({
    name: {
        type: 'string-required',
        index: 'partial',
    },
    description: {
        type: 'string-required',
        index: true,
    },
    ownerAccountId: {
        type: 'string-required',
        index: true,
    },
    visibleToAnyAdmin: {
        type: 'boolean-required',
        index: true,
    },
    visibleToOrgAdmins: {
        type: 'id-array-required',
        index: true,
    },
    filterBased: {
        type: 'boolean-required',
        index: true,
    },
    filterByColumns: {
        type: 'string-array',
        index: true,
    },
    criteriaString: {
        type: 'string-required',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    accountsImport: {
        type: 'boolean-required',
        index: true,
    },
});
